
import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import LanguageSwitcher from '../LanguageSwitcher';
import { useNavigationUtils } from '@/hooks/useNavigationUtils';

interface MobileNavigationProps {
  isMenuOpen: boolean;
  setIsMenuOpen: (isOpen: boolean) => void;
  isServicesActive: boolean;
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({ 
  isMenuOpen, 
  setIsMenuOpen,
  isServicesActive 
}) => {
  const { currentLanguage, getLocalizedPath } = useLanguage();
  const t = translations[currentLanguage];
  const { servicePages, isServiceActive, getServicePath, isWhyFutureLevelActive, getWhyFutureLevelPath } = useNavigationUtils();

  return (
    <div 
      className={`md:hidden bg-[#1A1F2C] shadow-md shadow-purple-800/20 border-t border-purple-900/20 overflow-hidden transition-all duration-500 ease-in-out z-40 ${
        isMenuOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
      }`}
    >
      <div className="container mx-auto px-4 py-4">
        <nav className="flex flex-col space-y-4">
          <Link 
            to={`/${currentLanguage}`}
            className="text-gray-100 hover:text-purple-400 transition-colors font-future tracking-wide text-sm relative group"
            onClick={() => setIsMenuOpen(false)}
          >
            <span>{t.home}</span>
            <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-purple-500/70 group-hover:w-full transition-all duration-300"></span>
          </Link>
          <div className="space-y-2 pl-4">
            <div className={`font-future ${isServicesActive ? 'text-purple-400' : 'text-gray-100'} tracking-wide text-sm`}>{t.services}</div>
            {servicePages.map((service) => {
              const servicePath = getServicePath(service.path);
              return (
                <Link 
                  key={service.key}
                  to={servicePath}
                  className={`block ${isServiceActive(service.path) ? 'text-purple-400' : 'text-gray-300 hover:text-purple-400'} transition-colors font-future tracking-wide text-sm relative group`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  <span>{t[service.key]}</span>
                  <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-purple-500/70 group-hover:w-full transition-all duration-300"></span>
                </Link>
              );
            })}
          </div>
          <Link 
            to={getWhyFutureLevelPath()}
            className={`text-gray-100 hover:text-purple-400 transition-colors font-future tracking-wide text-sm relative group ${
              isWhyFutureLevelActive() ? 'text-purple-400' : ''
            }`}
            onClick={() => setIsMenuOpen(false)}
          >
            <span>{t.whyFutureLevel}</span>
            <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-purple-500/70 group-hover:w-full transition-all duration-300"></span>
          </Link>
          <Link 
            to={getLocalizedPath('blog')}
            className="text-gray-100 hover:text-purple-400 transition-colors font-future tracking-wide text-sm relative group"
            onClick={() => setIsMenuOpen(false)}
          >
            <span>{t.blog}</span>
            <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-purple-500/70 group-hover:w-full transition-all duration-300"></span>
          </Link>
          <Link 
            to={getLocalizedPath('contact')}
            className="text-gray-100 hover:text-purple-400 transition-colors font-future tracking-wide text-sm relative group"
            onClick={() => setIsMenuOpen(false)}
          >
            <span>{t.contact}</span>
            <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-purple-500/70 group-hover:w-full transition-all duration-300"></span>
          </Link>
          <div className="pt-2">
            <LanguageSwitcher />
          </div>
        </nav>
      </div>
    </div>
  );
};

export default MobileNavigation;
